import {AuthService} from "./AuthService";

const FbServices = {
    auth: new AuthService(),
}

Object.freeze(FbServices);
export default FbServices;